<template>
	<v-container fluid style="text-align:left;  background-color: white !important;">
		<v-row align="center">
			<v-col cols="3">
				<v-img src="@/assets/ciclo-urbano.png" width="200px"></v-img>
			</v-col>
			<v-col cols="9" class="text-left overline">
				<div>
					UrbanPlagas SpA
				</div>
				<div>
					Diseño, mantención de areas verdes y manejo integral en control de plagas
				</div>
				<div>
					r.u.t 76.693.777-2
				</div>
				<div>Clorinda Henriquez 99, La reina, R.M.</div>
				<div>2 3217 22 11 / +56978901179</div>
				<a href="https://www.ciclourbano.cl" target="_blank" style="text-decoration: none">
					www.ciclourbano.cl
				</a>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="4">
				<div class="text-left">
					<span class="body-2"> Solicitado por: </span>
					<b :class="{ 'primary--text': hasInfo(order[2]) }">{{ order[2] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Correo: </span>
					<b :class="{ 'primary--text': hasInfo(order[order.length - 2]) }">{{
						order[order.length - 2]
					}}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Rut: </span>
					<b :class="{ 'primary--text': hasInfo(order[3]) }">{{ order[3] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Dirección: </span
					><b :class="{ 'primary--text': hasInfo(order[4]) }">{{ order[4] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Comuna / Ciudad: </span
					><b :class="{ 'primary--text': hasInfo(order[5]) }">{{ order[5] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="4">
				<div class="text-left">
					<span class="body-2"> Autorizado por: </span>
					<b :class="{ 'primary--text': hasInfo(order[6]) }">{{ order[6] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Rut: </span>
					<b :class="{ 'primary--text': hasInfo(order[7]) }">{{ order[7] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Dirección: </span
					><b :class="{ 'primary--text': hasInfo(order[8]) }">{{ order[8] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Comuna / Ciudad: </span
					><b :class="{ 'primary--text': hasInfo(order[9]) }">{{ order[9] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="4">
				<div class="text-left">
					<span class="body-2"> Fecha: </span>
					<b :class="{ 'primary--text': hasInfo(order[1]) }">{{ order[1] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> N° orden de trabajo: </span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }">{{ order[0] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2">Dirección perimetral:</span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }" v-if="place.address">{{
						place.address
					}}</b>
					<b :class="{ 'primary--text': hasInfo(order[0]) }" v-else
						>No hay perimetro establecido</b
					>
				</div>
				<div class="text-left" v-for="(email, index) in place.email" :key="index">
					<span class="body-2">Correo:</span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }">{{ email }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Tecnico engargado: </span>
					<b :class="{ 'primary--text': hasInfo(order[10]) }">{{ order[10] }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Control de palomas</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Mantencion: </span>
					<b :class="{ 'primary--text': hasInfo(order[11]) }">{{ order[11] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Asistencia: </span>
					<b :class="{ 'primary--text': hasInfo(order[12]) }">{{ order[12] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Perfiles desestabilizadores: </span>
					<b :class="{ 'primary--text': hasInfo(order[13]) }">{{ order[13] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Pinchos galvanizados: </span>
					<b :class="{ 'primary--text': hasInfo(order[14]) }">{{ order[14] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Malla hexagonal: </span>
					<b :class="{ 'primary--text': hasInfo(order[15]) }">{{ order[15] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2">
						Malla Monofilamento:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[16]) }">{{ order[16] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Espuma: </span>
					<b :class="{ 'primary--text': hasInfo(order[17]) }">{{ order[17] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Un: </span>
					<b :class="{ 'primary--text': hasInfo(order[18]) }">{{ order[18] }}</b>
					<span class="body-2"> Hilos </span>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Un: </span>
					<b :class="{ 'primary--text': hasInfo(order[19]) }">{{ order[19] }}</b>
					<span class="body-2"> Mts.</span>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Un: </span>
					<b :class="{ 'primary--text': hasInfo(order[20]) }">{{ order[20] }}</b>
					<span class="body-2"> Hilos</span>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Un: </span>
					<b :class="{ 'primary--text': hasInfo(order[21]) }">{{ order[21] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[22]) }">{{ order[22] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Limpieza de canaleta: </span>
					<b :class="{ 'primary--text': hasInfo(order[23]) }">{{ order[23] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Entretecho: </span>
					<b :class="{ 'primary--text': hasInfo(order[24]) }">{{ order[24] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2">
						Observaciones:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[25]) }">{{ order[25] }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Sanitizacion</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Mantención: </span>
					<b :class="{ 'primary--text': hasInfo(order[26]) }">{{ order[26] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Asistencia: </span>
					<b :class="{ 'primary--text': hasInfo(order[27]) }">{{ order[27] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Producto: </span>
					<b :class="{ 'primary--text': hasInfo(order[28]) }">{{ order[28] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Cantidad: </span>
					<b :class="{ 'primary--text': hasInfo(order[29]) }">{{ order[29] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Dosis: </span>
					<b :class="{ 'primary--text': hasInfo(order[30]) }">{{ order[30] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Baños:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[31]) }">{{ order[31] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Cocina:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[32]) }">{{ order[32] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Duchas/camarines:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[33]) }">{{ order[33] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Entretecho:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[34]) }">{{ order[34] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Vestidores:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[35]) }">{{ order[35] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						{{ order[37] }}
					</span>
					<b :class="{ 'primary--text': hasInfo(order[36]) }">{{ order[36] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						{{ order[39] }}
					</span>
					<b :class="{ 'primary--text': hasInfo(order[38]) }">{{ order[38] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						{{ order[41] }}
					</span>
					<b :class="{ 'primary--text': hasInfo(order[40]) }">{{ order[40] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2">
						Observaciones:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[42]) }">{{ order[42] }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Desratización</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Mantención: </span>
					<b :class="{ 'primary--text': hasInfo(order[43]) }">{{ order[43] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Asistencia: </span>
					<b :class="{ 'primary--text': hasInfo(order[44]) }">{{ order[44] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Monitoreo: </span>
					<b :class="{ 'primary--text': hasInfo(order[45]) }">{{ order[45] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						I.A:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[46]) }">{{ order[46] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Dosis:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[47]) }">{{ order[47] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Borde perimetral: </span>
					<b :class="{ 'primary--text': hasInfo(order[48]) }">{{ order[48] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Entretecho:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[49]) }">{{ order[49] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Alcantarillado:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[50]) }">{{ order[50] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Cocina:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[51]) }">{{ order[51] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Oficinas:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[52]) }">{{ order[52] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Bodega:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[53]) }">{{ order[53] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Sala de basura:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[54]) }">{{ order[54] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						{{ order[56] }}
					</span>
					<b :class="{ 'primary--text': hasInfo(order[55]) }">{{ order[55] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						{{ order[58] }}
					</span>
					<b :class="{ 'primary--text': hasInfo(order[57]) }">{{ order[57] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						{{ order[60] }}
					</span>
					<b :class="{ 'primary--text': hasInfo(order[59]) }">{{ order[59] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[61]) }">{{ order[61] }}</b>
					<span class="body-2">
						Caja Cebedera
					</span>
					<span class="body-2">
						{{ order[62] }}
					</span>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[63]) }">{{ order[63] }}</b>
					<span class="body-2">
						Captura viva
					</span>
					<span class="body-2">
						{{ order[64] }}
					</span>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[65]) }">{{ order[65] }}</b>
					<span class="body-2">
						Trampa pegajosa
					</span>
					<span class="body-2">
						{{ order[66] }}
					</span>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[67]) }">{{ order[67] }}</b>
					<span class="body-2">
						Tubo cebadero
					</span>
					<span class="body-2">
						{{ order[68] }}
					</span>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[69]) }">{{ order[69] }}</b>
					<span class="body-2">
						{{ order[70] }}
					</span>
					<span class="body-2">
						{{ order[71] }}
					</span>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[72]) }">{{ order[72] }}</b>
					<span class="body-2">
						{{ order[73] }}
					</span>
					<span class="body-2">
						{{ order[74] }}
					</span>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[75]) }">{{ order[75] }}</b>
					<span class="body-2">
						Cebo repuesto
					</span>
					<span class="body-2">
						{{ order[76] }}
					</span>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2">
						Observaciones:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[77]) }">{{ order[77] }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Desinsectación</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Mantención: </span>
					<b :class="{ 'primary--text': hasInfo(order[78]) }">{{ order[78] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Asistencia: </span>
					<b :class="{ 'primary--text': hasInfo(order[79]) }">{{ order[79] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Producto: </span>
					<b :class="{ 'primary--text': hasInfo(order[80]) }">{{ order[80] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Cantidad:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[81]) }">{{ order[81] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Dosis: </span>
					<b :class="{ 'primary--text': hasInfo(order[82]) }">{{ order[82] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Baños:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[83]) }">{{ order[83] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Oficinas:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[84]) }">{{ order[84] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Casino/comedor:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[85]) }">{{ order[85] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Interior:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[86]) }">{{ order[86] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Exterior:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[87]) }">{{ order[87] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Insectos voladores: </span>
					<b :class="{ 'primary--text': hasInfo(order[88]) }">{{ order[88] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Insectos rastreros: </span>
					<b :class="{ 'primary--text': hasInfo(order[89]) }">{{ order[89] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Cocina: </span>
					<b :class="{ 'primary--text': hasInfo(order[90]) }">{{ order[90] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Bodegas: </span>
					<b :class="{ 'primary--text': hasInfo(order[91]) }">{{ order[91] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Salas de basura: </span>
					<b :class="{ 'primary--text': hasInfo(order[92]) }">{{ order[92] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> {{ order[94] }}: </span>
					<b :class="{ 'primary--text': hasInfo(order[93]) }">{{ order[93] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Duchas/camarines: </span>
					<b :class="{ 'primary--text': hasInfo(order[95]) }">{{ order[95] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Habitacion: </span>
					<b :class="{ 'primary--text': hasInfo(order[96]) }">{{ order[96] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Sala de espera/Sala de ventas: </span>
					<b :class="{ 'primary--text': hasInfo(order[97]) }">{{ order[97] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> {{ order[99] }}: </span>
					<b :class="{ 'primary--text': hasInfo(order[98]) }">{{ order[98] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Entretecho: </span>
					<b :class="{ 'primary--text': hasInfo(order[100]) }">{{ order[100] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Borde perimetral: </span>
					<b :class="{ 'primary--text': hasInfo(order[101]) }">{{ order[101] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Hall de acceso: </span>
					<b :class="{ 'primary--text': hasInfo(order[102]) }">{{ order[102] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> {{ order[104] }}: </span>
					<b :class="{ 'primary--text': hasInfo(order[103]) }">{{ order[103] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2">
						Observaciones:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[105]) }">{{ order[105] }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Otros</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Mantención: </span>
					<b :class="{ 'primary--text': hasInfo(order[106]) }">{{ order[106] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Asistencia: </span>
					<b :class="{ 'primary--text': hasInfo(order[107]) }">{{ order[107] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2"> {{ order[109] }}: </span>
					<b :class="{ 'primary--text': hasInfo(order[108]) }">{{ order[108] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[110]) }">{{ order[110] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[111]) }">{{ order[111] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[112]) }">{{ order[112] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2"> {{ order[114] }}: </span>
					<b :class="{ 'primary--text': hasInfo(order[113]) }">{{ order[113] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[115]) }">{{ order[115] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[116]) }">{{ order[116] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[117]) }">{{ order[117] }}</b>
				</div>
			</v-col>
			<v-col sm="6" cols="12">
				<div class="text-left">
					<span class="body-2"> Observaciones: </span>
					<b :class="{ 'primary--text': hasInfo(order[118]) }">{{ order[118] }}</b>
				</div>
			</v-col>

			<v-col cols="12" v-if="hasInfo(order[119])">
				OT autorizada con fotografía:
				<v-img
					lazy-src="@/assets/placeholder.png"
					:src="order[120]"
					max-height="200px"
					max-width="200px"
					style="border-radius: 15px;"
					alt="imagen de la orden"
				>
					<div class="bg caption text-right">
						{{ dateTime }}
					</div>
				</v-img>
			</v-col>
			<template v-if="images">
				<v-col cols="12">
					Antecedentes fotográficos:
				</v-col>
				<div v-for="(img, key) in images" :key="key" class="d-flex child-flex ">
					<v-img
						lazy-src="@/assets/placeholder.png"
						:src="img.url"
						max-height="200px"
						max-width="200px"
						class="mr-1 mb-1"
						style="border-radius: 15px;"
						alt="imagen de la orden"
					>
						<div class="bg caption text-right" v-if="img.createdAt">
							{{ createAt(img.createdAt) }}
						</div>
					</v-img>
				</div>
			</template>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	props: {
		workOrder: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			idLodging: undefined,
			indexWorkOrder: undefined,
			order: [],
			place: '',
			images: [],
		};
	},
	computed: {
		dateTime() {
			return moment(this.order[119]).format('lll');
		},
		...mapGetters({
			lodgingSelect: 'Lodging/lodgingSelect',
		}),
	},
	watch: {
		workOrder() {
			this.order = this.workOrder;
		},
	},
	created() {
		if (!this.$vuetify.breakpoint.lgAndUp)
			document.getElementById('viewport').setAttribute('content', 'width=900');
	},
	mounted() {
		this.idLodging = this.$route.params.idLodging;
		this.indexWorkOrder = this.$route.params.index;

		if (this.workOrder) {
			this.order = this.formatWorkOrder(this.workOrder);
			this.place = this.lodgingSelect.place;
			if (this.lodgingSelect.documents) {
				const documents = this.lodgingSelect.documents;
				this.images = documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			}
		} else if (this.idLodging && this.indexWorkOrder)
			this.getWorkOrder({
				idLodging: this.idLodging,
				indexWorkOrder: this.indexWorkOrder,
			}).then(data => {
				this.order = this.formatWorkOrder(data.workOrder);
				this.place = data.place;
				this.images = data.documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			});
	},
	methods: {
		hasInfo(item) {
			return item !== 'Sin info';
		},
		createAt(date) {
			if (date) return moment(date).format('lll');
			else return 'Sin fecha';
		},
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		formatWorkOrder(workOrder) {
			return workOrder.map(item => {
				if (item === null || item === false) return 'Sin info';
				if (item === true) return 'Si';
				else return item;
			});
		},
		...mapActions({
			getWorkOrder: 'Lodging/getWorkOrder',
		}),
	},
};
</script>

<style scoped>
.bg {
	background-color: rgba(0, 0, 0, 0.1);
}
</style>
